export default "__VITE_ASSET__bQbIrfV9__"